import { Box, Checkbox, Stack, Typography } from "@mui/material";
import { ConsentContext } from "./provider.js";
import { ConsentInternalApiContext } from "./internal-api.js";
import { darken } from "color2k";
import React from "react";
export const Group = ({ group }) => {
    const backgroundColor = "#dff0f9";
    const color = darken(backgroundColor, 3.75);
    const borderColor = darken(backgroundColor, 0.1);
    const { processes } = React.useContext(ConsentContext);
    const { addGroup, grants, removeGroup } = React.useContext(ConsentInternalApiContext);
    const groupProcessIds = processes
        .filter(({ group: groupId }) => group.id === groupId)
        .map(({ id }) => id);
    const checked = grants.some(({ id }) => groupProcessIds.includes(id));
    const handleChange = (event) => {
        if (event.target.checked) {
            addGroup(group);
        }
        else {
            removeGroup(group);
        }
    };
    return (React.createElement(Box, { component: "li", sx: {
            px: 2,
            py: 1.5,
            backgroundColor,
            border: `1px solid ${borderColor}`,
            color,
            borderRadius: "8px",
        } },
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 2 },
            React.createElement(Checkbox, { checked: checked, disabled: group.required, onChange: handleChange, size: "small" }),
            React.createElement(Box, { sx: { flexGrow: 1 } },
                React.createElement(Typography, { variant: "h5", component: "div", role: "heading" }, group.name),
                React.createElement(Typography, { variant: "caption", component: "div" }, group.description)))));
};
//# sourceMappingURL=group.js.map